<template>
<div class="burns">
    <b-row>
        <b-col span="12">
            Display:
            <el-switch v-model="valueField" active-text="Total Stake" inactive-text="Node Count" :active-value="'active_stake'" :inactive-value="'count'" @change="updateChart"></el-switch>
        </b-col>
        <b-col span="12">
            Toggle Grouping:
            <el-button type="primary" @click="toggle('country')">Country</el-button>
            <el-button type="primary" @click="toggle('city')">City</el-button>
            <el-button type="primary" @click="toggle('autonomous_system_number')">Datacenter</el-button>
        </b-col>
    </b-row>
    <el-button-group>

    </el-button-group>
    <canvas id="chart"></canvas>
</div>
</template>

<script>
import { Chart, LinearScale } from "chart.js";

import {TreemapController, TreemapElement} from 'chartjs-chart-treemap';
Chart.register(TreemapController, TreemapElement);

const DATA_COUNT = 2500
const NUMBER_CFG = {count: DATA_COUNT, min: 2, max: 100}
let totalStake = 0
let totalNodes = 0
let maximumValue = 0
let groups = []
function colorFromValue(value, border) {
    let alpha = value / (maximumValue / 4 );
    const color = 'purple';
    if (border) {
        alpha += 0.05;
    }
    let rgba = 'rgba(200, 0, 200, ' + Math.max(alpha,.23) + ')'

    // console.log(maximumValue, rgba)
    return rgba;
}

export default {
    name: "TreeMap",
    props: ['data',],
    data() {
        return {
            groups: ['country'],
            totalStake: this.data.map(d => d.active_stake).reduce((a, b) => a + b, 0),
            valueField: 'active_stake',
            chart:null,

        }
    },
    mounted: function() {
        var ctx = document.getElementById("chart").getContext("2d");
        // console.log(this.totalStake)
        totalStake = this.totalStake
        totalNodes = this.data.length
        groups = this.groups
        maximumValue = this.valueField === 'active_stake' ? totalStake : totalNodes
        // console.log(this.data[0])

        let config = {
            type: "treemap",
            data: {
                datasets: [
                    {
                        tree: this.data,
                        key: this.valueField,
                        groups: ['country'],
                        backgroundColor(ctx) {
                            const item = ctx.dataset.data[ctx.dataIndex]
                            if(!item) return
                            return colorFromValue(item.v)
                        },
                        spacing: 0.1,
                        borderWidth: 1,
                        borderColor: 'rgba(180,180,180, 0.75)'


                    }
                ]
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false

                    },
                    title: {
                        display: true,
                        text: (ctx) => {
                            if (this.groups.length > 0 ) return 'Stake Distribution by ' + this.toTitleCase( this.groups.join(' / ') )
                            else return 'Stake Distribution by Validator'
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title(items) {
                                return items[0].dataset.key;
                            },
                            label(item) {
                                const dataItem = item.raw;

                                const obj = dataItem._data;
                                let label = ''
                                if (groups.length == 0) label = obj['name'] || obj['account']
                                groups.forEach(g => {
                                    if (obj[g]) label += obj[g] + ' / '
                                })
                                // trim trailing slash where we've added groups
                                if (groups.length > 0 ) label = label.slice(0, -3)

                                console.log(dataItem.v, totalStake)
                                if(dataItem.v > 1e6) return label + ': ' + (dataItem.v).toFixed(1) + ' (' + (dataItem.v / totalStake  * 100).toFixed(2) + '%)';
                                else return label + ': ' + dataItem.v + ' (' + (dataItem.v / totalNodes * 100).toFixed(2) + '%)';
                            }
                        }
                    }
                }
            }
        }

        // console.log(config)

        let c = new Chart(ctx, config);
        Object.seal(c)

        this.chart = c
        this.updateChart()

    },
    methods: {
        updateChart() {
            console.log('update')
            if(!this.chart) return

            this.chart.data.datasets[0].key = this.valueField;
            this.chart.data.datasets[0].groups = this.groups;
            // maximumValue = this.valueField == 'active_stake' ? totalStake : totalNodes
            // console.log(this.chart.data.datasets[0].key)
            // on next tick
            // this.$nextTick(() => {
            maximumValue= this.chart.data.datasets[0].data[0].v
            this.chart.update();
            // });
        },
        toggle(group) {
            const idx = this.groups.indexOf(group);
            if (idx === -1) {
                this.groups.push(group);
            } else {
                this.groups.splice(idx, 1);
            }
            groups = this.groups
            this.updateChart()
        },
        toTitleCase(phrase) {
            return phrase
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },

    },
};
</script>

<style scoped>
.burns {
    max-height:500px;
    /*color: white;*/
}
#chart {
    max-height:400px;

}
.null {
    background-color: rgba(255,0,0,1)
}
</style>
